import React from "react";
import { Box, Icon, Link, LinkProps } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { IconType } from "react-icons/lib";
interface NavLinkProps {
  to?: string;
  href?: string;
  label: string;
  icon?: IconType;
  hideLabel?: boolean;
  highlightLocation?: boolean;
}

type Props = NavLinkProps & LinkProps;

const NavLink: React.FC<Props> = ({
  to,
  href,
  icon,
  label,
  hideLabel = false,
  highlightLocation = false,
  ...rest
}: Props) => {
  const location = useLocation();
  const isCurrentLocation = to === location.pathname;

  return (
    <Link
      to={to}
      href={href}
      as={href ? "a" : RouterLink}
      py={5}
      px={8}
      borderRadius="xl"
      fontWeight="400"
      display="flex"
      alignItems="center"
      width="100%"
      bg={highlightLocation && isCurrentLocation ? "blue.500" : "unset"}
      color={highlightLocation && isCurrentLocation ? "gray.900" : "unset"}
      _hover={{
        bg: "blue.500",
        color: "gray.900"
      }}
      {...rest}
    >
      {icon && <Icon as={icon} h={8} w={8} mr={hideLabel ? 0 : 7} />}
      <Box hidden={hideLabel}>{label}</Box>
    </Link>
  );
};

export default NavLink;
